import Layout from '@/components/Layout';
import { PATH } from '@/constants/path';
import { getErrorFromAPI, handleToastMutation } from '@/helpers/toast';
import useConfirmationNavigate from '@/hooks/useConfirmationNavigate';
import { useGetNotificationAccountsQuery, useGetUserPlanQuery, useUpdateEmailAccountMutation } from '@/redux/api/api.caller';
import commonSlice from '@/redux/features/common.slice';
import { IEmailAccountPayload } from '@/types/notification';
import { Card, TextField } from '@shopify/polaris';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ControlBar } from '@/components';

const EmailRecipient = () => {
  const [recipientEmail, setRecipientEmail] = useState<string>('');
  const [loadedEmail, setLoadedEmail] = useState<string>('');
  const [apiError, setApiError] = useState<string>('');
  const dispatch = useDispatch();
  const navigate = useConfirmationNavigate();
  const { data } = useGetNotificationAccountsQuery();
  const { data: userPlanData } = useGetUserPlanQuery({});
  const [updateAccount, updateAccountData] = useUpdateEmailAccountMutation();
  const accountData = data?.data?.email?.account;

  const isDirty = recipientEmail !== loadedEmail;

  const handleChange = (value: string) => {
    setRecipientEmail(value);
    setApiError('');
  };

  const handleSave = () => {
    const updatedPayload: IEmailAccountPayload = { recipientEmail };
    updateAccount(updatedPayload).then((res) => {
      if ('data' in res && res.data && res.data?.state === 1) {
        setApiError('');
        setLoadedEmail(recipientEmail);
        dispatch(commonSlice.actions.handleToast(handleToastMutation(res)));
        return;
      }
      setApiError(getErrorFromAPI(res));
    });
  };

  const handleDiscard = () => {
    setRecipientEmail(loadedEmail);
    setApiError('');
  };

  useEffect(() => {
    const defaultEmail = accountData?.recipientEmail || userPlanData?.data?.crispData?.email || accountData?.email || '';
    setRecipientEmail(defaultEmail);
    setLoadedEmail(defaultEmail);
  }, [accountData, userPlanData?.data?.crispData?.email]);

  return (
    <Layout
      backAction={{ onAction: () => navigate(PATH.NOTIFICATIONS) }}
      title="Recipient email"
      subtitle="Set the email address you want to receive shipment updates"
    >
      <ControlBar
        isFixed
        hidden={!isDirty}
        actionGroup={[
          { content: 'Discard', onAction: handleDiscard, primary: false },
          { content: 'Save', onAction: handleSave, primary: true, disabled: !recipientEmail, loading: updateAccountData.isLoading },
        ]}
      />
      <Card>
        <TextField
          autoComplete="off"
          label="Recipient email"
          value={recipientEmail}
          onChange={handleChange}
          type="email"
          placeholder="Enter recipient email address"
          error={apiError}
        />
      </Card>
    </Layout>
  );
};

export default EmailRecipient;
